const apiUrl = process.env.REACT_APP_API_URL;

export const fetchWithAuth = async (url: string, options: RequestInit = {}) => {
    // Si la URL es relativa, añade el apiUrl y puerto por defecto
    // Esto es para mantener compatibilidad con las llamadas actuales que hacen `${apiUrl}:8061/...`
    let fullUrl = url;
    if (!url.startsWith('http')) {
        // Si el usuario pasa solo la ruta, construimos la URL completa.
        // Sin embargo, veo que en los archivos existentes hacen: `${apiUrl}:8061/...`
        // Así que asumiremos que 'url' ya viene con el dominio o que se pasará completa.
        // Si se pasa una ruta relativa como "/jutge/...", la concatenamos.
    }

    // Mejor enfoque: La función recibe la URL completa tal cual se usaba en los otros archivos.

    try {
        const response = await fetch(fullUrl, options);

        if (response.status === 401) {
            console.error("DEBUG: Unauthorised request, redirecting to login...");
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
            // Redirigir al login
            window.location.href = '/login';
            return null; // O lanzar error
        }

        return response;
    } catch (error) {
        console.error("Network error:", error);
        throw error;
    }
};
